<template>
  <VueApexCharts
    id="apexChart"
    class="apexChart"
    height="400px"
    width="100%"
    type="line"
    :options="getChartOptions()"
    :series="getSeriesData()"
  />
</template>

<script>
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'

export default {
  props: {
    scores: [Boolean, Object],
    stores: [Boolean, Array],
    scoreType: [String],
    scoreTypeMonths: [Number],
    blnCurrentMonth: [Boolean]
  },
  name: "ScoreHistoryChart",
  components: {
    VueApexCharts
  },
  computed: {
    getYAxisLabel() {
      return "score";
    },
    getChartTitle() {
      //include current month
      let text = this.scoreType == 'crs' ? 'cs' : this.scoreType
      let msg = `${text} scores for past ${this.scoreTypeMonths} months`;

      if (this.blnCurrentMonth) {
        msg = `${msg} including current month`;
      }

      return msg;
    }
  },
  methods: {
    getChartOptions() {
      return {
        chart: {
          id: "line-chart",
          fontFamily: 'Spartan, sans-serif',
          shadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 1
          },
          toolbar: {
            show: false
          },
          height: 400
        },

        dataLabels: {
          enabled: true
        },

        stroke: {
          curve: "straight"
        },

        title: {
          text: this.getChartTitle,
          align: "left",
          style: {
            fontSize: "18px",
            fontFamily: "Open Sans, sans-serif"
          }
        },

        grid: {
          borderColor: "#fff",
          row: {
            colors: ["#fff", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        markers: {
          size: 8
        },

        tooltip: {
          enabled: true,
          x: {
            show: true,
            formatter: val => {
              return this.getCategoryTitle(val - 1);
            }
          }
        },

        legend: {
          show: true,
          position: "top",
          horizontalAlign: "center",
          floating: false,
          offsetY: 250,
          offsetX: 0,
          height: 70
        },

        xaxis: {
          categories: this.getCategories(),
          title: {
            text: "months"
          }
        },
        yaxis: {
          title: {
            text: this.getYAxisLabel
          },
          max: function(max) { if(max > 100) return 100; return max },
          min: function(min) { if(min >= 100) return 0; return min },
          lines: {
            show: false
          }
        }
      };
    },

    getStoreName(seriesName) {
      const selectedStore = this.stores.filter(store => seriesName == store.id);
      if (selectedStore.length == 0) return false;
      return selectedStore[0].name;
    },

    getCategories() {
      const categories = Object.keys(this.scores).map(dateString => {
        return moment(dateString, "YYYY-MM").format("MMM YYYY").toLowerCase();
      });
      return categories;
    },

    getCategoryTitle(seriesIndex) {
      const categories = this.getCategories();
      const monthLabel = categories[seriesIndex];
      const dateObj = moment(monthLabel, "MMM YYYY");

      const monthString = dateObj.format("MMM");
      const yearString = dateObj.format("YYYY");

      const firstOfMonth = moment(
        monthLabel + " 01",
        "MMM YYYY DD"
      ).format("Do");

      const endOfMonth = moment(
        monthLabel + " " + dateObj.daysInMonth(),
        "MMM YYYY DD"
      ).format("Do");

      //if current months label
      if (this.blnCurrentMonth) {
        if (monthString == moment().format("MMM")) {
          const todaysDay = moment().format("Do");
          return `${monthString} ${firstOfMonth} through ${todaysDay} ${yearString}`.toLowerCase();
        }
      }

      //not current month label
      return `${monthString} ${firstOfMonth} through ${endOfMonth} ${yearString}`.toLowerCase();
    },

    getSeriesData() {
      const scores = this.scores; //our scores
      const months = Object.keys(scores); //all the months

      let ids = [];
      Object.values(scores).map(month => {
        Object.keys(month).map(store => {
          ids.push(store);
        });
      });
      const storeIds = [...new Set(ids)];

      const storesSeries = [];
      storeIds.forEach(store => {
        const singleStoreScores = [];
        months.forEach(month => {
          const calcVal = (((scores || {})[month] || {})[store] || {})
            .calculatedScore;
          if (!calcVal) {
            singleStoreScores.push(null);
          } else {
            singleStoreScores.push(scores[month][store].calculatedScore);
          }
        });

        storesSeries.push({
          name: this.getStoreName(store).toLowerCase(),
          data: singleStoreScores
        });
      });

      return storesSeries;
    }
  }
};
</script>